const INITIAL_STATE = {
  customerBranchesList: [],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'SET_CUSTOMER_BRANCHES': {
      return { ...state, customerBranchesList: action.customerBranches };
    }
    default:
      return state;
  }
};